import { ObservationCarousel } from 'pages/pointClouds/components/shared/ObservationCarousel'
import React from 'react'
import styled from 'styled-components'

interface ObservationImagePreviewProps {
  isOpen: boolean
  images: string[]
  onRemove: (index: number) => void
}

const ImagePreviewContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 150px;
  left: 760px;
  width: 200px;
  padding: 20px;
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  color: white;

  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateX(0)' : 'translateX(-284px)'};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition:
    transform 200ms ease-out,
    opacity 200ms ease-out;
`

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: white;
`

export const ObservationImagePreview: React.FC<
  ObservationImagePreviewProps
> = ({ isOpen, images, onRemove }) => {
  if (images.length === 0) {
    return null
  }

  return (
    <ImagePreviewContainer $isOpen={isOpen}>
      <Title>Preview Images</Title>
      <ObservationCarousel
        images={images}
        onRemove={onRemove}
        carouselProps={{
          dots: true,
          arrows: images.length > 1,
        }}
        imageStyle={{
          width: '100%',
          height: 'auto',
          display: 'block',
          maxHeight: '300px',
          objectFit: 'contain',
        }}
        style={{ width: '100%' }}
      />
    </ImagePreviewContainer>
  )
}
